<template>
  <b-container>
    <b-card
      border-variant="danger"
      :header="$t('Payment.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
    >
      <div class="text-center">
        <b-form-radio-group
          buttons
          block
          button-variant="outline-danger"
          v-model="paymentTypeSelected"
          :options="paymentTypes"
        />
      </div>

      <b-form @submit="checkFormSubmit" id="payment-form">
        <b-row class="my-2">
          <b-col class="pr-1">
            <b-form-input required :placeholder="$t('Payment.firstNamePlaceholder')" v-model="firstname" type="text"></b-form-input>
          </b-col>
          <b-col class="pl-1">
            <b-form-input required :placeholder="$t('Payment.lastNamePlaceholder')" v-model="lastname" type="text"></b-form-input>
          </b-col>
        </b-row>

        <div
          v-if="paymentTypeSelected === 'online'"
          class="credit-card-inputs"
          :class="{ complete }"
        >
          <b-row class="my-1">
            <b-col>
              <card-number
                class="stripe-element card-number"
                ref="cardNumber"
                :stripe="this.config.stripe.publishableKey"
                :options="this.stripeOptions"
                @change="number = $event.complete"
              />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col>
              <card-expiry
                class="stripe-element card-expiry"
                ref="cardExpiry"
                :stripe="this.config.stripe.publishableKey"
                :options="this.stripeOptions"
                @change="expiry = $event.complete"
              />
            </b-col>
            <b-col>
              <card-cvc
                class="stripe-element card-cvc"
                ref="cardCvc"
                :stripe="this.config.stripe.publishableKey"
                :options="this.stripeOptions"
                @change="cvc = $event.complete"
              />
            </b-col>
          </b-row>
        </div>
        <b-row class="my-3">
          <b-col>
            <h5 class="text-right">{{ $t('Payment.total') }}: {{cartAmount.total.toFixed(2)}} {{cartAmount.currency}}</h5>
            <p class="text-right">{{ $t('Payment.vat') }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-button :disabled="enableBtn" variant="danger" type="submit">{{ $t('Payment.continue') }}</b-button>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <div id="card-errors" role="alert"></div>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="error.received" variant="danger" class="text-center">{{error.msg}}</b-alert>
        </b-row>
      </b-form>
      <b-row v-if="paymentTypeSelected === 'online'" class="justify-content-left">
        <a href="https://stripe.com/" target="_blank">
          <img src="../../static/images/powered_by_stripe.svg" alt="Powered by STRIPE">
        </a>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
/* eslint-disable */
import {
  CardNumber,
  CardExpiry,
  CardCvc,
  createToken
} from "vue-stripe-elements-plus";
import { mapGetters } from "vuex";

export default {
  name: "Payment",
  props: ["stripe", "options"],
  data() {
    return {
      config: require("../config/config"),
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      stripeOptions: {
        style: {
          invalid: {
            color: "#721c24"
          }
        }
      },
      firstname: "",
      lastname: "",
      paymentTypeSelected: "online",
      paymentTypes: [
        { text: this.$i18n.t('Payment.online'), value: "online" },
        { text: this.$i18n.t('Payment.offline'), value: "offline" }
      ],
      error: {
        received: false,
        msg: ""
      }
    };
  },
  components: { CardNumber, CardExpiry, CardCvc },
  mounted() {
    // redirect to cart if cartAmount is empty
    if (!this.cartAmount || this.cartItems.length === 0)
      this.$router.push({ name: "Cart" });
  },
  methods: {
    update() {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    checkFormSubmit(e) {
      e.preventDefault();
      // check that first and last names contain proper values
      const regExp = /^[a-zA-Z0-9- ]{1,32}$/;
      if (!regExp.test(this.firstname)) {
        this.error.msg = this.$i18n.t('Payment.firstNameError');
        this.error.received = true;
      } else if (!regExp.test(this.lastname)) {
        this.error.msg = this.$i18n.t('Payment.lastNameError');
        this.error.received = true;
      }

      // if all good (offline)
      else if (this.paymentTypeSelected === "offline") {
        // navigate to payment confirmation page
        this.$router.push({
          name: "PaymentOfflineProcess",
          params: {
            name: this.fullName
          }
        });
      }

      // if all good (online)
      // get stripe token
      else {
        this.getStripeToken();
      }
    },
    getStripeToken() {
      createToken({ name: this.fullName })
        .then(token => {
          // set StripeToken state
          this.$store.dispatch("setStripeToken", token);

          // navigate to payment confirmation page
          this.$router.push({ name: "PaymentProcess" });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {
    number() {
      this.update();
    },
    expiry() {
      this.update();
    },
    cvc() {
      this.update();
    }
  },
  computed: {
    ...mapGetters({ cartAmount: "cartAmount", cartItems: "cartItems" }),
    fullName() {
      return this.firstname + " " + this.lastname;
    },
    enableBtn() {
      if (this.complete === true) {
        return false;
      } else if (
        this.paymentTypeSelected === "offline" &&
        this.firstname &&
        this.lastname
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style scoped>
.stripe-element {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.card-body {
  padding-bottom: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Payment.vue